import BaseService from "./_base.service";
import { PaymentMethod } from "../models/payment.method";

const endpoint = "payment/methods";

const PaymentMethodService = {
  ...BaseService<PaymentMethod>({ endpoint }),
};

export default PaymentMethodService;
